import { render } from "./stage4.vue?vue&type=template&id=bdad61f2&scoped=true"
import script from "./stage4.vue?vue&type=script&lang=js"
export * from "./stage4.vue?vue&type=script&lang=js"

import "./stage4.vue?vue&type=style&index=0&id=bdad61f2&scoped=true&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/_DKRx8o2/0/web/speechki_website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdad61f2"]])

export default __exports__